/* eslint-disable import/no-cycle */
import { createTheme, useTheme } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { getLocalData } from 'utils/localDataStore';
import _merge from 'lodash/merge';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import buildTheme, { applyFontOverrides } from 'utils/theme';
import { makeSelectClientDetails } from 'containers/Main/selectors';
import {
  themeConfig as blueshieldThemeConfig,
  // eslint-disable-next-line import/named
  getComponentStyles as getBlueshieldComponentStyles,
} from 'containers/Assessment/clients/blueshieldca';

const useClientTheme = () => {
  const defaultTheme = useTheme();
  const brand = getLocalData('brand')?.toLowerCase();
  const clientDetails = useSelector(makeSelectClientDetails());
  const location = useLocation();

  // Check if we're using BlueCross BlueShield brand
  const isBlueshieldBrand =
    brand === 'blueshieldca' ||
    brand === 'bscsmartscreen' ||
    brand === 'bscsmartscreenuat';

  // Check if client has custom fonts
  const hasCustomFont = !_isEmpty(
    _get(clientDetails, 'customFontsCollection.items', []),
  );

  // Start with base theme (either default or with custom fonts)
  let baseTheme = defaultTheme;

  if (hasCustomFont) {
    // Build theme with custom fonts if available
    baseTheme = buildTheme(
      _get(clientDetails, 'context.customHomeHeaderFont'),
      _get(clientDetails, 'context.customHomeBodyFont'),
      _get(clientDetails, 'context.customHomeHeroHeaderFont'),
    );
  }

  if (isBlueshieldBrand) {
    // Merge BlueCross BlueShield theme configuration with base theme
    const mergedTheme = _merge(
      {},
      baseTheme,
      blueshieldThemeConfig,
      getBlueshieldComponentStyles(location?.pathname),
    );

    // Apply font overrides if custom fonts exist
    const finalTheme = hasCustomFont
      ? applyFontOverrides(
          mergedTheme,
          _get(clientDetails, 'context.customHomeHeaderFont'),
          _get(clientDetails, 'context.customHomeBodyFont'),
          _get(clientDetails, 'context.customHomeHeroHeaderFont'),
        )
      : mergedTheme;

    return createTheme(finalTheme);
  }

  // For non-BlueCross BlueShield brands, return theme with custom fonts if available
  if (hasCustomFont) {
    return createTheme(baseTheme);
  }

  return defaultTheme;
};

export default useClientTheme;
